import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ReportePesosTable from "../ReportePesos/ReportePesosTable"
import { ReportePesosView } from "./ReportePesosView"
import { ReportePesosDelete } from "./ReportePesosDelete"
import ReportePesosService from "./ReportePesosService"
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

import { Breadcrumbs } from '../General/Breadcrumbs';
import authService from '../api-authorization/AuthorizeService'
import BLs_Table from './BLsTable';

export class ReportePesos_Index extends Component {
    static displayName = ReportePesos_Index.name;
    constructor(props) {
        super(props);
        
        this.state = {
            data: [],
            blsData: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            searchModel: { iD_Paleta: "", containeR_NUM: "", loaD_PORT: "", destino: "", naviera: "", viaje: ""  },
            semana: {},
            navieras: [],
            barcos: [],
            productores: [],
            destinos: [],
            barcosViaje: [],
            destinos: [],
            contenedores: [],
            numerosPaleta:[],
        };
        this.load_semana = this.load_semana.bind(this);
        this.load_navieras = this.load_navieras.bind(this);
        this.load_barcos = this.load_barcos.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
        this.printReport = this.printReport.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>     
                            <Col className="col-auto">
                                <FormGroup>
                                    <Label for="naviera">
                                        <FormattedMessage id='Naviera' />
                                    </Label>
                                    <Input
                                        id="naviera"
                                        name="naviera"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                       
                                    >
                                        <option value=""></option>
                                        {this.state.navieras.map(naviera => naviera == this.state.searchModel.naviera ? (
                                            <option value={naviera} selected>
                                                {naviera}
                                            </option>
                                        ) : (<option value={naviera}>{naviera}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Label for="destino">
                                        <FormattedMessage id='Destino' />
                                    </Label>
                                    <Input
                                        id="destino"
                                        name="destino"
                                        type="select"
                                        onChange={this.handleSearchChange}
                     
                                    >
                                        <option value=""></option>
                                        {this.state.destinos.map(destino => destino == this.state.searchModel.destino ? (
                                            <option value={destino} selected>
                                                {destino}
                                            </option>
                                        ) : (<option value={destino}>{destino}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            {/*<Col className="col-auto">*/}
                            {/*    <FormGroup>*/}
                            {/*        <Label for="viaje">*/}
                            {/*            <FormattedMessage id='Viaje' />*/}
                            {/*        </Label>*/}
                            {/*        <Input*/}
                            {/*            id="viaje"*/}
                            {/*            name="viaje"*/}
                            {/*            type="select"*/}
                            {/*            onChange={this.handleSearchChange}*/}

                            {/*        >*/}
                            {/*            <option value=""></option>*/}
                            {/*            {this.state.barcosViaje.map(viaje => viaje == this.state.searchModel.viaje ? (*/}
                            {/*                <option value={viaje} selected>*/}
                            {/*                    {viaje}*/}
                            {/*                </option>*/}
                            {/*            ) : (<option value={viaje}>{viaje}</option>))}*/}
                            {/*        </Input>*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            
                            
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            {/*<Col className="col-auto">*/}
                            {/*    <FormGroup>*/}
                            {/*        <Button className="DownloadButton IndexButton" onClick={this.printReport}>*/}
                            {/*            <DownloadOutlinedIcon fontSize='large' /> <FormattedMessage id='Descargar' />*/}
                            {/*        </Button>*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row className="mt-4">
                    <h2>Resumen de peso por BL</h2>
                    <BLs_Table data={this.state.blsData} />
                </Row>
                <Row className="my-2">
                    <h2>Resumen de peso por contenedor &#x2193;&#x2193;</h2>
                    <ReportePesosTable data={this.state.data} add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick} />
                </Row>
                <Modal size="lg" isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/Semanas", message: "Semanas", active: true },
                { link: "/Semanas/" + this.state.semana.semana_Id + "/ReportePesos", message: "ReporteDePesos", active: false },
            ]} />;
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div style={{ width: '100%' }}>
                <h2><FormattedMessage id='ReporteDePesos' /></h2>
                {breadcrumbsData}
                
                <div className="viewContainerHeader ">
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Semana' />: {this.state.semana.nombre}</div>
                        {/*<div className="px-4 py-2"><FormattedMessage id='Barco' />: {this.state.contenedorSemanal.barco}</div>*/}
                    </div>
                    <div className="d-flex justify-content-start">
                        {/*<div className="px-4 py-2"><FormattedMessage id='Proveedor' />: {this.state.proveedor.producto}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='Contenedor' />: {this.state.contenedorSemanal.contenedor}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='EtiquetaEspecial' />: {this.state.contenedorSemanal.etiquetaEspecial}</div>*/}
                    </div>
                </div>
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({
            loading: true, semana: await this.load_semana()
        },
            async () => {
            const token = await authService.getAccessToken();
            var queryString = '?semana_Id=' + this.state.semana.semana_Id;
            const response = await fetch('api/ContenedoresSemanales' + queryString, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            });
            const responceData = await response.json();
            const navieras = responceData.map(item => item.naviera).filter((value, index, self) => self.indexOf(value) === index);
            const destinos = responceData.map(item => item.destino).filter((value, index, self) => self.indexOf(value) === index);
            //const barcosViaje = responceData.map(item => item.vesseL_NAME + " - " + item.voyagE_NUMBER).filter((value, index, self) => self.indexOf(value) === index);
            //const destinos = responceData.map(item => item.loaD_PORT).filter((value, index, self) => self.indexOf(value) === index);
            //const contenedores = responceData.map(item => item.containeR_NUM).filter((value, index, self) => self.indexOf(value) === index);
            //const numerosPaleta = responceData.map(item => item.iD_Paleta).filter((value, index, self) => self.indexOf(value) === index);

            let data = responceData;
            //if (this.state.searchModel.iD_Paleta != "") {
            //    data = data.filter(x => x.iD_Paleta.includes(this.state.searchModel.iD_Paleta));
            //}
            //if (this.state.searchModel.containeR_NUM != "") {
            //    data = data.filter(x => x.containeR_NUM.includes(this.state.searchModel.containeR_NUM));
            //}
            //if (this.state.searchModel.loaD_PORT != "") {
            //    data = data.filter(x => x.loaD_PORT == this.state.searchModel.loaD_PORT);
                //}
            if (this.state.searchModel.naviera != "") {
                data = data.filter(x => x.grower == this.state.searchModel.naviera);
            }
            if (this.state.searchModel.destino != "") {
                data = data.filter(x => x.destino == this.state.searchModel.destino);
            }
            
            //if (this.state.searchModel.viaje != "") {
            //    data = data.filter(x => x.vesseL_NAME + " - " + x.voyagE_NUMBER == this.state.searchModel.viaje);
                //}

            let blsData = data.reduce((acc, item, index) => {
                // Find the existing group by 'bl'
                let group = acc.find(g => g.bl === item.bl && g.destino === item.destino);

                if (!group) {
                    // If the group doesn't exist, create a new one
                    group = {
                        fake_Id: acc.length + 1, // Assign a unique ID based on the current number of groups
                        destino: item.destino,
                        bl: item.bl,
                        contenedores: "",
                        pesoNeto: 0,
                        pesoBruto: 0,
                        paletizados: 0,
                        cajas: 0,
                        pesoTara: 0,
                        vgm: 0
                    };
                    acc.push(group);
                }

                // Append the contenedor to the group as a comma-separated string
                group.contenedores = group.contenedores
                    ? group.contenedores + ", " + item.contenedor
                    : item.contenedor;

                // Add all values to their respective sums (consider null as 0)
                group.pesoNeto += item.pesoNeto || 0;
                group.pesoBruto += item.pesoBruto || 0;
                group.paletizados += item.paletizados || 0;
                group.cajas += item.cajas || 0;
                group.pesoTara += item.pesoTara || 0;
                group.vgm += item.vgm || 0;

                return acc;
            }, []);
            console.log('blsData', blsData)

            this.setState({ data: data, blsData: blsData, loading: false, navieras: navieras, destinos: destinos });

        });
    }

    async handleSearchChange(event) {
        event.preventDefault();
        var searchModel = this.state.searchModel;
        searchModel[event.target.name] = event.target.value;
        this.setState({ searchModel: searchModel }, async () => {
            if (event.target.name == "naviera_Id") {
                this.setState({
                    barcos: await this.load_barcos()
                });
            }
        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><ReportePesosView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState}></ReportePesosView></div>);
        //return (<div><ReportePesosView ref={this.modalBodyState}></ReportePesosView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/reportePesos', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/reportePesos/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><ReportePesosView operation={ this.state.modalOperation} setModalBodyState={this.setModalBodyState} data={responceData}></ReportePesosView></div>);
        //return (<div><ReportePesosView ref={this.modalBodyState}></ReportePesosView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/reportePesos/' + this.modalBodyState.reportePeso_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/reportePesos/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><ReportePesosDelete setModalBodyState={this.setModalBodyState} data={responceData}></ReportePesosDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/reportePesos/' + this.modalBodyState.reportePeso_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            searchModel: { iD_Paleta: "", containeR_NUM: "", loaD_PORT: "", description: "", grower: "", viaje: "" },
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_semana() {
        var rawUrl = window.location.toString();
        var semana_Id = rawUrl.split("Semanas/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/semanas/' + semana_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_navieras() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/navieras/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_barcos() {
        if (this.state.searchModel.naviera_Id != 0) {
            const token = await authService.getAccessToken();
            const response = await fetch('api/barcos?naviera_Id=' + this.state.searchModel.naviera_Id, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });
            return await response.json();
        }
        else {
            return [];
        }
    }
    async printReport() {
        console.log("printReport");
        await new ReportePesosService().ReportePesos(this.state.semana);
        console.log("end");
    }
}